import { render, staticRenderFns } from "./ActivityHistoryRegistration.vue?vue&type=template&id=f06f3386&scoped=true&"
import script from "./ActivityHistoryRegistration.vue?vue&type=script&lang=js&"
export * from "./ActivityHistoryRegistration.vue?vue&type=script&lang=js&"
import style0 from "./ActivityHistoryRegistration.vue?vue&type=style&index=0&id=f06f3386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06f3386",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCheckbox,VCombobox,VDialog,VForm,VSelect,VTextarea})
